import CloseIcon from '@mui/icons-material/Close';
import { DatePicker } from '@mui/lab';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import { Autocomplete, Button, FormControl, FormHelperText, Grid, InputLabel, MenuItem, Select, TextField, Typography } from '@mui/material';
import Drawer from '@mui/material/Drawer';
import React, { useEffect, useState } from 'react';
import AutocompleteLoader from '../common/AutocompleteLoader';
import request from '../../utils/request';
import { checkPermission } from 'src/utils/permission';

function AdvancedFilter({ hideFilter, submitFilter, formik, setCorporateCustomerDatas, corporateCustomerDatas, setRetailCustomerDatas, retailCustomerDatas,
    setCompanyBranchData, companyBranchData, insuranceCompanyList, setInsuranceCompanyList, setPolicyProductData, policyProductData
}) {
    const fetchData = () => {
        submitFilter();
        hideFilter();
    };

    const all_option = { branchName: 'All', id: 'ALL' };
    const userDetail = JSON.parse(localStorage.getItem('userDatas'));
    const [noOptionsTextFlag, setNoOptionsTextFlag] = useState(false);
    const [clickBranch, setClickBranch] = useState([]);
    const [insuCompanyBranchSerachValue, setinsuCompanyBranchSerachValue] = useState('');
    const [inputValue, setInputValue] = useState('');

    const [reportingManegerLoading, setReportingManegerLoading] = useState(false);
    const [relationSerachData, setRelationSerachData] = useState('');
    const [relationValue, setRelationValue] = useState(null);
    const [relationSerachValue, setRelationSerachValue] = useState('');

    //Co-Customer auto complete
    const [corporateCustomerSearchValue, setCorporateCustomerSearchValue] = useState('');
    const [corporateCustomerValue, setCorporateCustomerValue] = useState('');
    const [coCustomerLoader, setCoCustomerLoader] = useState(null);
    const [corporateCustomerEmptyFlag, setCorporateCustomerEmptyFlag] = useState(false);
    //#End

    //Ret-Cust Auto complete    
    const [retailCustomerSearchValue, setRetailCustomerSearchValue] = useState('');
    const [retailCustomerValue, setRetailCustomerValue] = useState('');
    const [retCustomerLoader, setRetCustomerLoader] = useState(null);

    const [retailCustomerEmptyFlag, setRetailCustomerEmptyFlag] = useState(false);
    const [productLoader, setProductLoader] = useState(null);
    const [policyProductSearchValue, setPolicyProductSearchValue] = useState('');
    const [policyProductViewPermission, setPolicyProductViewPermission] = useState(false);
    const [userViewPermission, setUserViewPermission] = useState(false);
    const [companyViewPermission, setCompanyViewPermission] = useState(false);
    const [companyBranchPermission, setCompanyBranchViewPermission] = useState(false);
    const [corporateCustomersViewPermission, setCorporateCustomersViewPermission] = useState(false);
    const [customerViewPermission, setCustomerViewPermission] = useState(false);

    const checkPermissions = async () => {
        await checkPermission('Products', 'view').then((permission) => {
            setPolicyProductViewPermission(permission);
        });


        await checkPermission('User', 'view').then((permission) => {
            setUserViewPermission(permission);
        });

        await checkPermission('CorporateCustomers', 'view').then((permission) => {
            setCorporateCustomersViewPermission(permission);

        });
        await checkPermission('RetailCustomer', 'view').then((permission) => {
            setCustomerViewPermission(permission);
        });

        await checkPermission('InsuranceCompany', 'view').then((permission) => {
            setCompanyViewPermission(permission);
        });

        await checkPermission('InsuranceCompanyBranch', 'view').then((permission) => {
            setCompanyBranchViewPermission(permission);

        });
    }

    const getpolicyProductData = (selectedIds?: any) => {
        setProductLoader(true);
        setPolicyProductData([]);
        request({
            url: 'policyProduct/getAllowedPolicyProducts',
            method: 'post',
            data: {
                limit: 1000,
                offset: 0,
                orderColumn: 'id',
                orderDirection: 'ASC',
                categoryIds: selectedIds || []
            }
        }).then(
            (response: any) => {
                setProductLoader(false);
                if (response?.status == false) {
                    setNoOptionsTextFlag(true);
                    setPolicyProductData([]);
                } else {
                    setNoOptionsTextFlag(false);
                    setPolicyProductData([all_option, ...response]);
                }
            },
            (error) => {
                setProductLoader(false);
                console.log(error);
            }
        );
    };

    useEffect(() => {
        if (
            formik.values.insuranceCompanyId &&
            formik.values.insuranceCompanyId.length > 0
        ) {
            getInsuranceCompanyBranchList();

        } else {
            setCompanyBranchData([]);

        }
    }, [formik.values.insuranceCompanyId]);

    const getInsuranceCompanyBranchList = () => {
        request({
            url: 'company-branch/getCompanyBranchListByCompanyArray',
            method: 'POST',
            data: {
                search: null,
                orderColumn: 'id',
                orderDirection: 'DESC',
                offset: 0,
                limit: 1000,
                deleteStatus: false,
                companyArray: formik.values.insuranceCompanyId
            }
        })
            .then((response: any) => {
                console.log('InsuranceCompanyBranch', response);
                if (
                    response.companyBranchData &&
                    response.companyBranchData.length > 0
                ) {
                    setCompanyBranchData([all_option, ...response.companyBranchData]);
                } else {
                    setCompanyBranchData([]);
                }
            })
            .catch(function (err) { });
    };

    const getInsuranceCompanyList = async () => {
        request({
            url: 'insurencecompany/getInsurenceCompanyList',
            method: 'POST',
            data: {
                limit: 5000,
                offset: 0,
                orderColumn: 'id',
                orderDirection: 'ASC'
            }
        }).then(
            (response: any) => {
                setInsuranceCompanyList([all_option, ...response.insurencecompanyData]);
            },
            (error) => {
                console.log(error);
            }
        );
    };



    //Get Co-Customer
    React.useEffect(() => {
        if (formik.values.customerType == 'Corporate')
            getCorporateCustomerDatas();

    }, [formik.values.customerType, corporateCustomerSearchValue]); // multiple api call

    const getCorporateCustomerDatas = async () => {
        setCoCustomerLoader(true);
        setCorporateCustomerDatas([]);
        request({
            url: 'user/getAllowedCorporateCustomerList',
            method: 'post',
            data: {
                search: corporateCustomerSearchValue,
                orderColumn: 'id',
                orderDirection: 'DESC',
                limit: 1000,
                offset: 0,
                status: true
            }
        }).then(
            (response) => {
                setCoCustomerLoader(false);
                setCorporateCustomerDatas([all_option, ...response['customerData']]);
                if (response['customerData'].length === 0)
                    setCorporateCustomerEmptyFlag(true);


                //#End
            },
            (error) => {
                setCoCustomerLoader(false);
                console.log(error);
            }
        );
    };
    //#End

    React.useEffect(() => {
        if (formik.values.customerType == 'Retail')
            getRetailCustomerDatas();
    }, [formik.values.customerType, retailCustomerSearchValue]); ///multiple api call

    const getRetailCustomerDatas = async () => {
        setRetCustomerLoader(true);
        setRetailCustomerDatas([]);
        request({
            url: 'user/getAllowedCustomerList',
            method: 'post',
            data: {
                search: retailCustomerSearchValue,
                limit: 1000,
                orderColumn: 'id',
                orderDirection: 'DESC',
                status: true
            }
        }).then(
            (response) => {
                setRetCustomerLoader(false);
                setRetailCustomerDatas([all_option, ...response['customerData']]);
                if (response['customerData'].length === 0)
                    setRetailCustomerEmptyFlag(true);

            },
            (error) => {
                setRetCustomerLoader(false);
                console.log(error);
            }
        );
    };

    useEffect(() => {
        getInsuranceCompanyList();
        getpolicyProductData();
        checkPermissions();
    }, [])

    const clearBranchList = () => {
        setCompanyBranchData([]);
    };


    return (
        <Drawer anchor={'right'} open={true} onClose={hideFilter}>
            <CloseIcon onClick={hideFilter} sx={{ cursor: 'pointer', mt: 1 }} />
            <Grid container sx={{ width: 500 }} mt={2} mb={1} spacing={1}>

                {/* Start Date Picker */}
                {/* <Grid xs={12} mr={2} ml={3} mt={2}>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                            views={['year', 'month', 'day']}
                            inputFormat="dd-MM-yyyy"
                            maxDate={
                                formik.values?.endDate
                                    ? new Date(formik.values.endDate) < new Date()
                                        ? new Date(formik.values.endDate)
                                        : new Date()
                                    : new Date()
                            }

                            label={
                                <>
                                    Start Date {' '}
                                    <Typography component="span" sx={{ color: 'red' }}>
                                        *
                                    </Typography>
                                </>
                            }
                            value={formik.values?.startDate}
                            onChange={(value) => formik.setFieldValue('startDate', value, true)}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    sx={{ width: '100%', borderColor: 'red' }}
                                    size="small"
                                    name="StartDate"
                                    onKeyDown={(e) => e.preventDefault()}
                                />
                            )}
                        />
                    </LocalizationProvider>
                </Grid> */}

                {/* End Date Picker */}
                {/* <Grid xs={12} mr={2} ml={3} mt={2}>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                            views={['year', 'month', 'day']}
                            inputFormat="dd-MM-yyyy"
                            maxDate={new Date()}
                            label={
                                <>
                                    End Date {' '}
                                    <Typography component="span" sx={{ color: 'red' }}>
                                        *
                                    </Typography>
                                </>
                            }

                            minDate={formik.values?.startDate} // Set minimum date for end date
                            value={formik.values?.endDate}
                            onChange={(value) => formik.setFieldValue('endDate', value, true)}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    sx={{ width: '100%', borderColor: 'red' }}
                                    size="small"
                                    name="endDate"
                                    onKeyDown={(e) => e.preventDefault()}
                                />
                            )}
                        />
                    </LocalizationProvider>
                </Grid> */}
                <Grid xs={12} mr={2} ml={3} mt={2}>
                    <Autocomplete
                        multiple
                        id="policyProduct"
                        disabled={!policyProductViewPermission}
                        noOptionsText="No Data Found"
                        options={
                            policyProductData.length === 1 &&
                                policyProductData[0]?.id === 'ALL'
                                ? []
                                : policyProductData
                        }

                        getOptionLabel={(option) => option?.name || 'All'}
                        isOptionEqualToValue={(option, value) =>
                            option?.id === value?.id
                        }
                        size="small"
                        value={formik.values.policyProductId}
                        onChange={(event, newValue) => {
                            const allSelected = newValue.some(
                                (opt) => opt?.id === 'ALL'
                            );
                            if (allSelected) {
                                formik.setFieldValue('policyProductId', [
                                    { id: 'ALL', name: 'All' }
                                ]);
                            } else {
                                formik.setFieldValue('policyProductId', newValue);
                            }
                        }}
                        onBlur={() => {
                            formik.setFieldTouched('policyProductId', true);
                            setPolicyProductSearchValue('');
                        }


                        }
                        inputValue={policyProductSearchValue}
                        onInputChange={(event, newInputValue, reason) => {
                            if (reason === 'input') {
                                setPolicyProductSearchValue(newInputValue);
                            }
                        }}
                        renderOption={(props, option, { selected }) => {
                            const allSelected = formik.values.policyProductId?.some(
                                (opt) => opt?.id === 'ALL'
                            );
                            return (
                                <li
                                    {...props}
                                    aria-disabled={allSelected && option.id !== 'ALL'}
                                    style={{
                                        opacity:
                                            allSelected && option.id !== 'ALL' ? 0.5 : 1
                                    }}
                                >
                                    {option?.name || 'All'}
                                </li>
                            );
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                name="policyProductId"
                                label="Select Product"
                                placeholder="Search Product"
                                error={
                                    formik.touched.policyProductId &&
                                    Boolean(formik.errors.policyProductId)
                                }
                                helperText={
                                    !policyProductViewPermission
                                        ? (
                                            <span style={{ color: 'red' }}>
                                                You don’t have permission to access Product
                                            </span>
                                        )
                                        : formik.touched.policyProductId && formik.errors.policyProductId
                                }


                                InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                        <AutocompleteLoader
                                            params={params}
                                            loader={productLoader}
                                        />
                                    )
                                }}
                            />
                        )}
                    />
                </Grid>


                <Grid xs={12} mr={2} ml={3} mt={2}>
                    <TextField
                        select
                        name="customerType"
                        sx={{ width: '100%' }}
                        size="small"
                        type="text"
                        label={
                            <React.Fragment>
                                Select Type{' '}
                                {/* <Typography component="span" sx={{ color: 'red' }}>
                                                                                    *
                                                                                </Typography> */}
                            </React.Fragment>
                        }
                        value={formik.values.customerType}
                        onChange={(e) => {
                            setCorporateCustomerSearchValue('');
                            setRetailCustomerSearchValue('');

                            formik.setFieldValue('customerIds', [
                                { id: 'ALL', companyName: 'All' }
                            ]);

                            formik.handleChange(e);
                        }}
                        onBlur={formik.handleBlur}
                        error={
                            formik.touched.customerType &&
                            Boolean(formik.errors.customerType)
                        }
                        helperText={
                            formik.touched.customerType && formik.errors.customerType
                        }

                        InputLabelProps={{
                            style: { color: '#6B6B6B', fontSize: '0.875rem' },
                        }}

                    >    <MenuItem value="All">All</MenuItem>
                        <MenuItem value="Corporate">Corporate Customer</MenuItem>
                        <MenuItem value="Retail">Retail Customer</MenuItem>
                    </TextField>
                </Grid>


                {formik.values.customerType === 'Corporate' ? (
                    <Grid xs={12} mr={2} ml={3} mt={2}>
                        <Autocomplete
                            multiple
                            // disableClearable={!corporateCustomerSearchValue}
                            id="customerIds"
                            disabled={
                                formik.values.customerType === 'All' ||
                                !corporateCustomersViewPermission
                            }
                            noOptionsText="No Data Found"
                            options={corporateCustomerDatas}
                            getOptionLabel={(option) => option?.companyName || 'All'}
                            isOptionEqualToValue={(option, value) => option?.id === value?.id}
                            size="small"
                            value={formik.values.customerIds}
                            onChange={(event, newValue) => {
                                // Optional: handle "ALL" selection if needed
                                const allSelected = newValue.some(opt => opt?.id === "ALL");
                                if (allSelected) {
                                    formik.setFieldValue('customerIds', [{ id: 'ALL', companyName: 'All' }]);
                                } else {
                                    formik.setFieldValue('customerIds', newValue);
                                }
                            }}
                            onBlur={() => formik.setFieldTouched('customerIds', true)}
                            inputValue={corporateCustomerSearchValue}
                            onInputChange={(event, newInputValue, reason) => {
                                if (reason === 'input') {
                                    setCorporateCustomerSearchValue(newInputValue);
                                }
                            }}
                            renderOption={(props, option, { selected }) => {
                                const allSelected = formik.values.customerIds?.some(opt => opt?.id === 'ALL');
                                return (
                                    <li
                                        {...props}
                                        aria-disabled={allSelected && option.id !== 'ALL'}
                                        style={{ opacity: allSelected && option.id !== 'ALL' ? 0.5 : 1 }}
                                    >
                                        {option?.companyName || 'All'}
                                    </li>
                                );
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    name="customerIds"
                                    label="Select Customer"
                                    placeholder="Search Customer Name"
                                    error={formik.touched.customerIds && Boolean(formik.errors.customerIds)}
                                    helperText={
                                        !corporateCustomersViewPermission
                                            ? (
                                                <span style={{ color: 'red' }}>
                                                    You don’t have permission to access Customer
                                                </span>
                                            )
                                            : formik.touched.customerIds && formik.errors.customerIds
                                    }
                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <AutocompleteLoader
                                                params={params}
                                                loader={coCustomerLoader}
                                            />
                                        ),
                                    }}
                                />
                            )}
                        />


                    </Grid>
                ) : (
                    <Grid xs={12} mr={2} ml={3} mt={2}>


                        <Autocomplete
                            multiple
                            // disableClearable={!retailCustomerSearchValue}
                            id="retailCustomerId"
                            disabled={
                                formik.values.customerType === 'All' ||
                                !customerViewPermission
                            }
                            noOptionsText="No Data Found"
                            options={retailCustomerDatas}
                            getOptionLabel={(option) => option?.name || 'All'}
                            isOptionEqualToValue={(option, value) => option?.id === value?.id}
                            size="small"
                            value={formik.values.customerIds}
                            onChange={(event, newValue) => {
                                const allSelected = newValue.some(opt => opt?.id === "ALL");
                                if (allSelected) {
                                    formik.setFieldValue('customerIds', [{ id: 'ALL', name: 'All' }]);
                                } else {
                                    formik.setFieldValue('customerIds', newValue);
                                }
                            }}
                            onBlur={() => formik.setFieldTouched('customerIds', true)}
                            inputValue={retailCustomerSearchValue}
                            onInputChange={(event, newInputValue, reason) => {
                                if (reason === 'input') {
                                    setRetailCustomerSearchValue(newInputValue);
                                }
                            }}
                            renderOption={(props, option, { selected }) => {
                                const allSelected = formik.values.customerIds?.some(opt => opt?.id === 'ALL');
                                return (
                                    <li
                                        {...props}
                                        aria-disabled={allSelected && option.id !== 'ALL'}
                                        style={{ opacity: allSelected && option.id !== 'ALL' ? 0.5 : 1 }}
                                    >
                                        {option?.name || 'All'}
                                    </li>
                                );
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    name="customerIds"
                                    label="Select Customer"
                                    placeholder="Search Customer Name"
                                    error={formik.touched.customerIds && Boolean(formik.errors.customerIds)}
                                    helperText={
                                        !customerViewPermission
                                            ? (
                                                <span style={{ color: 'red' }}>
                                                    You don’t have permission to access Retail Customer
                                                </span>
                                            )
                                            : formik.touched.customerIds && formik.errors.customerIds
                                    }
                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <AutocompleteLoader
                                                params={params}
                                                loader={retCustomerLoader}
                                            />
                                        ),
                                    }}
                                />
                            )}
                        />



                    </Grid>
                )}


                <Grid xs={12} mr={2} ml={3} mt={2}>
                    <Autocomplete
                        multiple
                        size="small"
                        // disableClearable
                        options={insuranceCompanyList}
                        disabled={!companyViewPermission}
                        getOptionLabel={(option) => option?.name || 'All'}
                        value={insuranceCompanyList.filter((item) =>
                            formik.values.insuranceCompanyId.includes(item.id)
                        )}
                        onChange={(_, newValue) => {
                            const allSelected = newValue.some(opt => opt?.id === 'ALL');

                            if (allSelected) {
                                formik.setFieldValue('insuranceCompanyId', ['ALL']);
                            } else {
                                const ids = newValue.map((item) => item.id);
                                formik.setFieldValue('insuranceCompanyId', ids);
                            }

                            clearBranchList();
                            setClickBranch([]);
                            formik.setFieldValue('insurancBranchId', []);
                            setinsuCompanyBranchSerachValue('');
                        }}
                        onBlur={() => formik.setFieldTouched('insuranceCompanyId', true)}
                        renderOption={(props, option) => {
                            const allSelected = formik.values.insuranceCompanyId?.includes('ALL');
                            return (
                                <li
                                    {...props}
                                    aria-disabled={allSelected && option.id !== 'ALL'}
                                    style={{ opacity: allSelected && option.id !== 'ALL' ? 0.5 : 1 }}
                                    key={option.id}
                                >
                                    {option?.name || 'All'}
                                </li>
                            );
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Insurance Company"
                                error={formik.touched.insuranceCompanyId && Boolean(formik.errors.insuranceCompanyId)}
                                helperText={
                                    !companyViewPermission
                                        ? (
                                            <span style={{ color: 'red' }}>
                                                You don’t have permission to access Insurance Company
                                            </span>
                                        )  // ✅ Show permission message
                                        : formik.touched.insuranceCompanyId &&
                                        formik.errors.insuranceCompanyId
                                }
                            />
                        )}
                        isOptionEqualToValue={(option, value) => option.id === value.id}
                    />

                </Grid>


                <Grid xs={12} mr={2} ml={3} mt={2}>
                    <FormControl size="small" fullWidth>
                        <Autocomplete
                            multiple
                            size="small"
                            disableClearable
                            filterSelectedOptions
                            id="insuranceBranch"
                            disabled={
                                formik.values.insuranceCompanyId?.length < 1 ||
                                formik.values.insuranceCompanyId?.includes('ALL') ||
                                !companyBranchPermission
                            }
                            options={companyBranchData || []}
                            getOptionLabel={(option) => option?.branchName || ''}

                            value={(companyBranchData || []).filter((item) =>
                                formik.values.insurancBranchId?.includes(item.id)
                            )}

                            onChange={(event, newValue) => {
                                const allSelected = newValue?.some(
                                    (opt) => opt?.id === 'ALL'
                                );

                                if (allSelected) {
                                    formik.setFieldValue(
                                        'insurancBranchId',
                                        ['ALL']
                                    );
                                } else {
                                    formik.setFieldValue(
                                        'insurancBranchId',
                                        newValue.map((item) => Number(item.id))
                                    );
                                }

                                setinsuCompanyBranchSerachValue('');
                            }}

                            // ✅ search text state
                            inputValue={insuCompanyBranchSerachValue || ''}

                            onInputChange={(event, newInputValue, reason) => {
                                if (reason === 'input' || reason === 'clear') {
                                    setinsuCompanyBranchSerachValue(newInputValue);
                                }
                            }}

                            noOptionsText="No Data Found"

                            renderOption={(props, option) => {
                                const allSelected =
                                    formik.values.insurancBranchId?.includes('ALL');

                                return (
                                    <li
                                        {...props}
                                        aria-disabled={
                                            allSelected && option.id !== 'ALL'
                                        }
                                        style={{
                                            opacity:
                                                allSelected && option.id !== 'ALL'
                                                    ? 0.5
                                                    : 1,
                                            pointerEvents:
                                                allSelected && option.id !== 'ALL'
                                                    ? 'none'
                                                    : 'auto'
                                        }}
                                    >
                                        {option.branchName || 'All'}
                                    </li>
                                );
                            }}

                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    name="insurancBranchId"
                                    label="Insurance Company Branch"
                                    error={
                                        formik.touched.insurancBranchId &&
                                        Boolean(formik.errors.insurancBranchId)
                                    }
                                    helperText={
                                        !companyBranchPermission ? (
                                            <span style={{ color: 'red' }}>
                                                You don’t have permission to access
                                                Insurance Company Branch
                                            </span>
                                        ) : (
                                            formik.touched.insurancBranchId &&
                                            formik.errors.insurancBranchId
                                        )
                                    }
                                    onBlur={() =>
                                        formik.setFieldTouched(
                                            'insurancBranchId',
                                            true
                                        )
                                    }
                                />
                            )}

                            isOptionEqualToValue={(option, value) =>
                                option.id === value.id
                            }
                        />
                    </FormControl>
                </Grid>


                {/* Apply Filter Button */}
                <Grid xs={12} mt={2} textAlign="center">
                    <Button
                        variant="contained"
                        onClick={fetchData}
                    // disabled={
                    //     !formik.values?.startDate ||
                    //     !formik.values?.endDate
                    // }
                    >
                        Apply Filter
                    </Button>
                </Grid>

            </Grid>
        </Drawer>
    );
}

export default AdvancedFilter;
